export default __webpack_public_path__ + "static/webRotator/svg/b2f132b97b0371281141c3c0d3565e68.svg";